import { ref } from 'ui.vue3';
import { defineStore } from 'ui.vue3.pinia';

export default defineStore('user', () => {

    const fullName = ref('');
    const email = ref('');
    const phone = ref('');
    const companyId = ref('');
    const companyName = ref('');

    return { companyId, companyName, fullName, email, phone };

});
